import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'

Vue.component(FeatherIcon.name, FeatherIcon)

const   mainBaseUrl = process.env.VUE_APP_BASE_URL
const  mainSocketUrl = process.env.VUE_APP_SOCKET_URL
export default mainBaseUrl
